module.exports = __webpack_public_path__ + "img/level0.f8173a26.svg";